module.exports = __webpack_public_path__ + "fonts/SuisseIntl-SemiBold.91dd693.ttf";